import { Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { SpaceTab } from 'api/space';
import { ReactComponent as SpaceTabThumbnail } from 'assets/svgs/folded-file.svg';
import { CpBody00Primary } from 'components/atoms/customer-portal/typography';
import { RocketDocument32 } from 'components/atoms/icons';
import { CpSpacesEmptyState } from './cp-spaces-empty-state';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 174px);
  gap: var(--cp-spacing-05);
  justify-content: start;
`;

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid var(--cp-gray-20);
  border-radius: var(--border-radius-sm);
  width: 174px;
  height: 174px;
  cursor: pointer;
`;

const FileNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  padding-top: var(--cp-spacing-05);
  padding-bottom: var(--cp-spacing-05);
  padding-left: var(--cp-spacing-06);
  padding-right: var(--cp-spacing-06);
  overflow: hidden;
`;

const FileName = styled(CpBody00Primary)`
  margin-bottom: 0;
  /* ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  flex: 1 1 auto;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--cp-gray-10);
  position: relative;

  ${GridItem}:hover & {
    background: var(--cp-gray-20);
  }

  .folded-file-svg {
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
  }
  .rl-document-svg {
    fill: var(--cp-blue-50);
  }
`;

export const SrcIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  overflow: hidden;
  position: relative;
  z-index: 100;
  /* top: calc(50% + 20px); */
  top: calc(50% + 0px);
  left: 50%;
  transform: translate(-50%, -50%);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Item: React.FC<{
  spaceTab: SpaceTab;
  onClick: () => void;
}> = ({ spaceTab, onClick }) => {
  const iconSrc =
    Array.isArray(spaceTab.metaData?.links?.icon) &&
    spaceTab.metaData?.links?.icon[0]?.href;

  return (
    <GridItem onClick={onClick}>
      <ImageWrapper>
        <SpaceTabThumbnail className="folded-file-svg" />
        <SrcIconWrapper>
          {iconSrc ? (
            <img src={iconSrc} alt={spaceTab.spaceTabTitle} />
          ) : (
            <RocketDocument32 className="rl-document-svg" />
          )}
        </SrcIconWrapper>
      </ImageWrapper>
      <Tooltip title={spaceTab.spaceTabTitle}>
        <FileNameWrapper>
          <FileName>{spaceTab.spaceTabTitle}</FileName>
        </FileNameWrapper>
      </Tooltip>
    </GridItem>
  );
};

export const CpSpacesGridView: React.FC<{
  spaceTabs: SpaceTab[];
  onSpaceTabClick: (spaceTab: SpaceTab) => void;
}> = ({ spaceTabs, onSpaceTabClick }) => {
  return spaceTabs?.length ? (
    <Grid>
      {spaceTabs.map((spt) => {
        return (
          <Item
            key={spt.spaceTabId}
            spaceTab={spt}
            onClick={() => onSpaceTabClick(spt)}
          />
        );
      })}
    </Grid>
  ) : (
    <CpSpacesEmptyState />
  );
};
